import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Loader2, Users } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/pages/AuthPage";
import { api, formatApiError } from "@/lib/api";
import { useApp } from "@/lib/i18n";
import { useAuth } from "@/context/AuthContext";

export default function JoinWorkspace() {
  const { L } = useApp();
  const { token } = useParams();
  const { user, refresh, selectWs } = useAuth();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/public/invite/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(formatApiError(e))); }, [token]);
  const accept = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/invite/${token}/accept`);
      sessionStorage.removeItem("minitai-join");
      await refresh();
      selectWs(data.workspace_id);
      toast.success(data.already ? L("Anda sudah ahli workspace ini.", "You're already a member.") : L(`Selamat datang ke ${info.workspace_name}!`, `Welcome to ${info.workspace_name}!`));
      navigate("/app");
    } catch (e) { toast.error(formatApiError(e)); setBusy(false); }
  };
  const back = { onClick: () => sessionStorage.setItem("minitai-join", token) };
  return (
    <AuthShell>
      <div className="space-y-5" data-testid="join-page">
        {!info && !error && <Loader2 className="animate-spin text-violet-600" />}
        {error && <><h1 className="text-3xl font-extrabold tracking-tight">{L("Jemputan tidak sah", "Invalid invite")}</h1><p className="text-sm text-red-700" data-testid="join-error">{error}</p><Link to="/" className="text-sm font-semibold text-violet-700">{L("Ke laman utama", "Go home")}</Link></>}
        {info && (
          <>
            <div className="grid h-12 w-12 place-items-center rounded-2xl bg-violet-50 text-violet-600"><Users size={22} /></div>
            <h1 className="text-3xl font-extrabold tracking-tight">{L(`Sertai ${info.workspace_name}`, `Join ${info.workspace_name}`)}</h1>
            <p className="text-sm text-slate-500">{L(`${info.inviter} menjemput anda sebagai `, `${info.inviter} invited you as `)}<strong className="text-slate-800" data-testid="join-role">{info.role_label}</strong>.</p>
            {user
              ? <Button onClick={accept} disabled={busy} className="h-11 w-full rounded-xl bg-violet-600 hover:bg-violet-700" data-testid="join-accept-btn">{L("Terima & sertai", "Accept & join")}</Button>
              : <div className="grid gap-2">
                  <Button asChild className="h-11 rounded-xl bg-violet-600 hover:bg-violet-700" data-testid="join-register-btn"><Link to="/register" {...back}>{L("Daftar untuk menyertai", "Sign up to join")}</Link></Button>
                  <Button asChild variant="outline" className="h-11 rounded-xl" data-testid="join-login-btn"><Link to="/login" {...back}>{L("Sudah ada akaun? Log masuk", "Have an account? Log in")}</Link></Button>
                </div>}
          </>
        )}
      </div>
    </AuthShell>
  );
}
